import { render, staticRenderFns } from "./DetailExample.vue?vue&type=template&id=7971344c&"
import script from "./DetailExample.vue?vue&type=script&lang=js&"
export * from "./DetailExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports